import React from 'react';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import {
  LINE_ITEM_SHIPPING_FEE,
  LINE_ITEM_SHIPPING_OPTION,
  propTypes,
} from '../../util/types';

import css from './OrderBreakdown.module.css';

const LineItemShippingFeeMaybe = props => {
  const { lineItems, intl } = props;

  const shippingFeeLineItem = lineItems.find(
    item =>
      (item.code === LINE_ITEM_SHIPPING_FEE && !item.reversal) ||
      (item.code === LINE_ITEM_SHIPPING_OPTION && !item.reversal)
  );

  return shippingFeeLineItem ? (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        {shippingFeeLineItem.displayName || (
          <FormattedMessage
            id="OrderBreakdown.shippingDefault"
            defaultMessage="Shipping"
          />
        )}
      </span>
      <span className={css.itemValue}>
        {formatMoney(intl, shippingFeeLineItem.unitPrice)}
      </span>
    </div>
  ) : null;
};

LineItemShippingFeeMaybe.propTypes = {
  lineItems: propTypes.lineItems.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemShippingFeeMaybe;
